'use client';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import Container from '@mui/material/Container';
import Slide from '@mui/material/Slide';
import Image from 'next/image';
import { AppDataModel } from '@/lib/appData';
import Link from 'next/link';

interface HeaderProps {
  data: AppDataModel;
  window?: () => Window;
  children?: React.ReactElement<unknown>;
}

function HideOnScroll(props: HeaderProps) {
  const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
  });

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children ?? <div />}
    </Slide>
  );
}

const Header: React.FC<HeaderProps> = (props) => {

  const { data } = props;

  return (
    <>
      <HideOnScroll {...props}>
        <AppBar 
          elevation={0}
          sx={{
            bgcolor: theme => theme.vars.palette.background.paper,
            color: theme => theme.vars.palette.text.primary,
            borderBottom: theme => `2px solid ${theme.vars.palette.primary.main}`,
          }}
        >
          <Toolbar>
            <Container>
              <Link href={'/'}>
                <Image
                  src={data.logo}
                  alt={data.name}
                  width={162}
                  height={47}
                />
              </Link>
            </Container>
          </Toolbar>
        </AppBar>
      </HideOnScroll>
      <Toolbar />
    </>
  );
}

export default Header